// imports...
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, useMediaQuery, MenuItem, Select, Typography, IconButton } from "@mui/material";
import DashboardCard from "../../../../components/Cards/DashboardCard";
import PresentIcon from "../../../../assets/StatusIcons/PresentIcon.svg";
import AbsentIcon from "../../../../assets/StatusIcons/AbsentIcon.svg";
import HalfLeaveIcon from "../../../../assets/StatusIcons/HalfLeaveIcon.svg";
import dashboardmap from "../../../../assets/Dashboard/dashboardmap.png";
import mapicon from "../../../../assets/Dashboard/mapicon.svg";
import CustomButton from "../../../../components/CustomButton";
import maparrow from "../../../../assets/maparrow.svg";
import ClientAcquisitionTable from "./DashboardClients.js";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from '../../../../components/BaseUrl';
import EarlyOutIcon from "../../../../assets/StatusIcons/EarlyOutIcon.svg";
import LeaveIcon from "../../../../assets/StatusIcons/LeaveIcon.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import back from "../../../../assets/back.svg";

import LateIcon from "../../../../assets/StatusIcons/LateIcon.svg"
import { useLocation, useNavigate } from 'react-router-dom';

import clockout from "../../../../assets/Dashboard/clockout.svg";
import breakstart from "../../../../assets/Dashboard/breakstart.svg";
import breakend from "../../../../assets/Dashboard/breakend.svg";
import ontimeclockin from "../../../../assets/Dashboard/ontimeclockin.svg";
import lateclockin from "../../../../assets/Dashboard/lateclockin.svg";
import lateclockout from "../../../../assets/Dashboard/lateclockout.svg";
import activeemployee from "../../../../assets/Dashboard/activeemployee.svg";
import presenttodayworker from "../../../../assets/Dashboard/presenttodayworker.svg";
import absentworker from "../../../../assets/Dashboard/absentworker.svg";
import pendingworkers from "../../../../assets/Dashboard/pendingworkers.svg";
import pendingtask from "../../../../assets/Dashboard/pendingtask.svg";
import pendingrequests from "../../../../assets/Dashboard/pendingrequests.svg";
import pendingdocuments from "../../../../assets/Dashboard/pendingdocuments.svg";
import pendingexpense from "../../../../assets/Dashboard/pendingexpense.svg";
import icon1 from "../../../../assets/LastetIcons/icon1.svg";
import icon2 from "../../../../assets/LastetIcons/icon2.svg";
import icon3 from "../../../../assets/LastetIcons/icon3.svg"
import icon4 from "../../../../assets/LastetIcons/icon4.svg"
import icon5 from "../../../../assets/LastetIcons/icon5.svg"
import icon6 from "../../../../assets/LastetIcons/icon6.svg"
import icon7 from "../../../../assets/LastetIcons/icon7.svg"
import icon8 from "../../../../assets/LastetIcons/icon8.svg"
import icon9 from "../../../../assets/LastetIcons/icon9.svg"

import icon10 from "../../../../assets/LastetIcons/icon10.svg"
import icon11 from "../../../../assets/LastetIcons/icon11.svg"

import icon12 from "../../../../assets/LastetIcons/icon12.svg"
import icon13 from "../../../../assets/LastetIcons/icon13.svg"
import icon14 from "../../../../assets/LastetIcons/icon14.svg"
import icon15 from "../../../../assets/LastetIcons/icon15.svg"
import icon16 from "../../../../assets/LastetIcons/icon16.svg"
import icon17 from "../../../../assets/LastetIcons/icon17.svg"

import icon18 from "../../../../assets/LastetIcons/icon18.svg"
import icon19 from "../../../../assets/LastetIcons/icon19.svg"
import icon20 from "../../../../assets/LastetIcons/icon20.svg"
const TodaysLogs = () => {
  const { t, i18n, ready } = useTranslation();
  const isMobile = useMediaQuery("(max-width:768px)");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
const location = useLocation();
const initialStatus = location.state?.initialStatus || "";
  const navigate = useNavigate();
  const fromDashboard = location.state?.fromDashboard;
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const handleRowClick = (row) => {
    setSelectedRowData(row);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRowData(null);
  };
  const handleViewDetails = () => {
    setIsModalOpen(false);
    setIsDetailModalOpen(true);
  };
  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedRowData(null);
  };

  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const getToday = () => new Date().toISOString().split("T")[0];

 const [liveAttendance, setLiveAttendance] = useState(null);
  const [liveLoading, setLiveLoading] = useState(true);
  const [liveError, setLiveError] = useState(null);
  const [unvalidatedCount, setUnvalidatedCount] = useState(0);
  const {
    inboxCount = 0,
    accountExecutiveCount = 0,
    superAdminCount = 0,
  } = useSelector((state) => state.messageCount || {});
  const totalMessageCount = inboxCount + accountExecutiveCount + superAdminCount;

  useEffect(() => {
    const fetchLiveAttendance = async () => {
      if (!decryptedToken) return;
      setLiveLoading(true);
      setLiveError(null);
      try {
        const res = await fetch(`${BASE_URL}/company-admins/attendance/today`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        const json = await res.json();
        if (json?.error) {
          setLiveError(json?.message || "Failed to fetch live attendance");
        } else {
          setLiveAttendance(json?.data || null);
        }
      } catch (err) {
        console.error("Error fetching live attendance:", err);
        setLiveError("Network error while fetching live attendance");
      } finally {
        setLiveLoading(false);
      }
    };

    fetchLiveAttendance();
  }, [decryptedToken]);

  // Fetch unvalidated punches count
  useEffect(() => {
    const fetchUnvalidatedCount = async () => {
      if (!decryptedToken) return;
      try {
        const res = await fetch(`${BASE_URL}/company-admins/attendance/unvalidated?no_pagination=true&status=PENDING`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
        });
        const json = await res.json();
        if (!json?.error && json?.data?.punches) {
          setUnvalidatedCount(json.data.punches.length || 0);
        }
      } catch (err) {
        console.error("Error fetching unvalidated count:", err);
      }
    };

    fetchUnvalidatedCount();
  }, [decryptedToken]);

   const counters = liveAttendance?.counters || {};
  const rows =
    liveAttendance?.table?.rows ||
    liveAttendance?.rows ||
    [];

  const safeNum = (val) => (typeof val === "number" ? val : "-");

const [selectedFilter, setSelectedFilter] = useState(initialStatus);
const [isFilterApplied, setIsFilterApplied] = useState(Boolean(initialStatus));
useEffect(() => {
  if (initialStatus) {
    setSelectedFilter(initialStatus);
    setIsFilterApplied(true);
  }
}, [initialStatus]);

  const totals = overview?.totals || {};
  if (!ready) return <div>Loading translations...</div>;

  return (
    <Box sx={{ pl: isMobile ? 0.5 : 1.5, pr: isMobile ? 0.5 : 0, py: 2 }}>

      {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}





<Box
  sx={{
    display: "grid",
    gap: 1,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)", // show all six in a row on large screens
      xl: "repeat(5, 1fr)",
    },
  }}
>
<DashboardCard
    icon={icon1}
    title={t("activeEmployeeRegistration")}
    description={liveLoading ? "…" : safeNum(counters.activeEmployeeRegistration)}
    onClick={() => navigate("/all-employees", { state: { fromDashboard: true, filterStatus: "active" } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon2}
    title={t("ClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeePresentToday)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}
    cardSx={{cursor:"pointer"}}
  />


  <DashboardCard
    icon={icon3}
    title={t("ClockOut")}
    description={liveLoading ? "…" : safeNum(counters.clockout)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />
<DashboardCard
    icon={icon4}
    title={t("break_start")}
    description={liveLoading ? "…" : safeNum(counters.breakStart)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon5}
    title={t("break_end")}
    description={liveLoading ? "…" : safeNum(counters.breakEnd)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

  {/* 1. Pending Employee Registration */}


  {/* 2. Active Employee Registration */}


  {/* 3. Clock In today */}


  {/* 4. On Time Clock In today */}
  {/* <DashboardCard
    icon={ontimeclockin}
    title={t("OnTimeClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeeArrivingOnTime)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  /> */}

  {/* 5. Late Clock In today */}


  {/* 6. Start Break today */}






</Box>


   <Box
  sx={{
    display: "grid",
    gap: 1,
    mt:1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)", // show all six in a row on large screens
      xl: "repeat(5, 1fr)",
    },
  }}
>
 
<DashboardCard
    icon={icon6}
    title={t("LateClockIn")}
    description={liveLoading ? "…" : safeNum(counters.employeeArrivingLate)}
       onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />
<DashboardCard
    icon={icon7}
    title={t("LateClockOut")}
    description={liveLoading ? "…" : safeNum(counters.lateClockOut)}
        onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />


<DashboardCard
    icon={icon8}
    title={"Early Clock In"}
    description={liveLoading ? "…" : safeNum(counters.earlyClockIn)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

  <DashboardCard
    icon={icon9}
    title={t("attendanceStatus.early_clock_out")}
    description={liveLoading ? "…" : safeNum(counters.earlyOut ?? counters.earlyClockOut)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true, initialStatus: "earlyOut" } })}
    cardSx={{ cursor: "pointer" }}
  />


<DashboardCard
    icon={icon10}
    title={t("employees_absent")}
    description={liveLoading ? "…" : safeNum(counters.employeeAbsent)}
            onClick={() => navigate("/absence", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  />

  

  {/* 7. End Break today */}

  {/* 8. Clock Out today */}


  {/* 9. On Time Clock Out today */}

  {/* <DashboardCard
    icon={ontimeclockin}
    title={t("OnTimeClockOut") || "On Time Clock Out"}
    description={liveLoading ? "…" : safeNum(onTimeClockOut)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true,} })}

    cardSx={{cursor:"pointer"}}
  /> */}

  {/* 10. Late Clock Out today */}

  {/* 11. Absences today */}


  {/* 12. Pending tasks */}

</Box>

   <Box
  sx={{
    display: "grid",
    gap: 1,
    mt: 1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)",
      xl: "repeat(5, 1fr)",
    },
  }}
>

<DashboardCard
    icon={icon11}
    title={t("unvalidatedPunches.title") || "Unvalidated Records"}
    description={unvalidatedCount}
    onClick={() => navigate("/unvalidated-punches", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />


<DashboardCard
    icon={icon12}
    title={"Validated Punches"}
    description={liveLoading ? "…" : safeNum(counters.validatedPunches)}
    onClick={() => navigate("/unvalidated-punches", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />


<DashboardCard
    icon={icon13}
    title={"Day Leave"}
    description={liveLoading ? "…" : safeNum(counters.dayLeave)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

  <DashboardCard
    icon={icon14}
    title={"Half Day Leave"}
    description={liveLoading ? "…" : safeNum(counters.halfDayLeave)}
    onClick={() => navigate("/todays-logs", { state: { fromDashboard: true } })}
    cardSx={{ cursor: "pointer" }}
  />

<DashboardCard
    icon={icon15}
    title={t("pendingTask")}
    description={liveLoading ? "…" : safeNum(counters.pendingTask)}
    onClick={() => navigate("/all-tasks", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />


  {/* 14. Employee requests */}


  {/* 15. Employee documents */}


  {/* 16. Reimbursement requests */}


  {/* 17. Unvalidated records */}

</Box>

  <Box
  sx={{
    display: "grid",
    gap: 1,
    mt: 1.5,
    gridTemplateColumns: {
      xs: "repeat(2, 1fr)",
      sm: "repeat(3, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(5, 1fr)",
      xl: "repeat(5, 1fr)",
    },
  }}
>
<DashboardCard
    icon={icon16}
    title={t("pendingRequests")}
    description={liveLoading ? "…" : safeNum(counters.pendingRequests)}
    onClick={() => navigate("/request-management", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon17}
    title={t("pendingReimbursementRequests")}
    description={liveLoading ? "…" : safeNum(counters.pendingReimbursementRequests)}
    onClick={() => navigate("/Reimbursement-request", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />
  <DashboardCard
    icon={icon18}
    title={t("pendingReceivedDocuments")}
    description={liveLoading ? "…" : safeNum(counters.pendingReceivedDocuments)}
    onClick={() => navigate("/worker-documents", { state: { fromDashboard: true, } })}
    cardSx={{cursor:"pointer"}}
  />

<DashboardCard
    icon={icon19}
    title={t("pendingEmployeeRegistrations")}
    description={liveLoading ? "…" : safeNum(counters.pendingEmployeeRegistration)}
    onClick={() => navigate("/all-employees", { state: { fromDashboard: true, filterStatus: "pending" } })}
    cardSx={{cursor:"pointer"}}
  />
  {/* 13. Employee messages */}
  <DashboardCard
    icon={icon20}
    title={t("sidebar.messages")}
    description={totalMessageCount}
    onClick={() => navigate("/messages", { state: { fromDashboard: true, } })}

    cardSx={{cursor:"pointer"}}
  />
</Box>
      {/* Map header + image (unchanged) */}
   
    
      <Box sx={{ position: "relative", mt: 1, display: "flex", alignItems: "flex-start", justifyContent: "flex-start", gap: 2, flexWrap: isMobile ? "wrap" : "nowrap", width: "100%" }}>
        <Box sx={{ width: "100%", overflowX: "auto"}}>
          <ClientAcquisitionTable onRowClick={handleRowClick}
              initialFilter={selectedFilter}
 />
        </Box>
      </Box>
    </Box>
  );
};

export default TodaysLogs;
